import React, { useReducer, createContext } from 'react';
import { initialState } from '../state/initialState';
import {
  CREATE_CAMPAIGN,
  DELETE_CAMPAIGN,
  START_CAMPAIGN,
  CREATE_DATASET,
  DELETE_DATASET,
  SET_COLUMN_FILTERS,
} from './actionTypes';
import { getColumnsFromData } from '../helpers/getColumns';
import { setFilterInArray } from '../helpers/filter';

export const MainContext = createContext();

const deleteEntryBasedOnName = (stateArr, name) => stateArr.filter((entry) => entry.name !== name);

const createNewDatasetEntry = (data, name, state) => {
  const newEntry = {
    name,
    data,
    columns: getColumnsFromData(data),
    datasetId: 2342,
    dataset: null,
  };
  return [...state.dataSets, newEntry];
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET_DATASET':
      return {
        ...state,
        dataset: payload.dataset,
      };

    case CREATE_DATASET:
      return {
        ...state,
        dataSets: createNewDatasetEntry(payload.data, payload.name, state),
      };
    case DELETE_DATASET:
      return {
        ...state,
        dataSets: deleteEntryBasedOnName([...state.dataSets], payload),
      };
    case CREATE_CAMPAIGN:
      return {
        ...state,
        campaigns: [...state.campaigns, payload],
      };
    case DELETE_CAMPAIGN:
      return {
        ...state,
        campaigns: deleteEntryBasedOnName([...state.campaigns], payload),
      };
    case SET_COLUMN_FILTERS:
      const updatedFilters = setFilterInArray(
        state.columnFilters,
        { id: payload.filterKey, value: payload.filterValue },
      );

      return {
        ...state,
        columnFilters: [...updatedFilters],
      };
    case 'SET_ACTIVE_CAMPAIGN':
      return {
        ...state,
        campaign: {
          ...state.campaign,
          id: payload.id,
        },
      };
    case 'INIT_COLUMN_FILTERS':
      return {
        ...state,
        columnFilters: payload.filters,
      };
    case START_CAMPAIGN:
      return state;
    default:
      throw new Error();
  }
};

function MainContextProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <MainContext.Provider value={[state, dispatch]}>
      {props.children}
    </MainContext.Provider>
  );
}

export default MainContextProvider;
